import React from 'react';

import { DatabaseOrderField, OrderDirection } from '../../../../../../gen-src/queries';
import { DefaultDirections, SortProviderProps, UrlSortProvider } from '../../../../data-catalog-shared';

export type DatabasesValidSortFields =
  DatabaseOrderField.NAME |
  DatabaseOrderField.DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT |
  DatabaseOrderField.DOWNSTREAM_DATASOURCES_COUNT |
  DatabaseOrderField.DOWNSTREAM_WORKBOOKS_COUNT |
  DatabaseOrderField.CONNECTION_TYPE |
  DatabaseOrderField.IS_CERTIFIED;


export const DatabasesDefaultDirections: DefaultDirections<DatabasesValidSortFields> = {
  [DatabaseOrderField.NAME]: OrderDirection.ASC,
  [DatabaseOrderField.DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT]: OrderDirection.DESC,
  [DatabaseOrderField.DOWNSTREAM_DATASOURCES_COUNT]: OrderDirection.DESC,
  [DatabaseOrderField.DOWNSTREAM_WORKBOOKS_COUNT]: OrderDirection.DESC,
  [DatabaseOrderField.CONNECTION_TYPE]: OrderDirection.ASC,
  [DatabaseOrderField.IS_CERTIFIED]: OrderDirection.DESC, // Certified items at the top
};

export const DatabasesDefaultSortField = DatabaseOrderField.DOWNSTREAM_WORKBOOKS_COUNT;

export function DatabasesGridSortProvider(
  props: Pick<SortProviderProps<DatabasesValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<DatabasesValidSortFields>
      validOrderFieldsWithDefaultDirections={DatabasesDefaultDirections}
      defaultField={DatabasesDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
